import module from '../module';
import * as _ from 'lodash';
import scopeUtils from '../../../utils/scope';
import CommonConstants from "../../../utils/CommonConstants";

export class OrderTabAddPeopleController {

    static $inject = [ '$scope', '$rootScope', 'GroupOrder', 'Message' ];

    constructor(scope, $rootScope, groupOrderService, messageService) {
        this.scope = scope;

        scope.onContactListChanged = function (emails) {
            scope.configuration.contactDetails.selectedEmails = emails || scope.configuration.contactDetails.selectedEmails || [];
            scope.nextDisabled = scope.checkDisableGoingForward();
            scopeUtils.apply(scope);
        };

        scope.checkDisableGoingForward = () => {
            return _.isEmpty(scope.configuration.contactDetails.selectedEmails)
                && _.isEmpty(scope.configuration.contactDetails.selectedContacts);
        };

        scope.configuration = {
            contactDetails: groupOrderService.getContactDetails() || {
                selectedContacts: [],
                createdGroups: [],
                createdContacts: [],
                allContacts: [],
                allGroups: [],
                selectedEmails: []
            }
        };


        scope.$on('order:add:people.canAddPeople', function (s, value) {
            scope.canAddEmail = value;
            scope.nextDisabled = scope.checkDisableGoingForward();
            scopeUtils.apply(scope);
        });

        scope.sendInvitation = function (emails) {
            groupOrderService.setContactDetails(scope.configuration.contactDetails);

            const nextDisabled = scope.checkDisableGoingForward();

            if (!nextDisabled) {
                scope.next();
            }
        };

        scope.addPeopleToOrder = function () {
            scope.$broadcast(CommonConstants.Events.ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE);
        };

        scope.goBack = () => {
            scope.back();
        }

        scope.onDeleteContact = async (contact) => {
            scope.onDialogDeleteContact(contact);
        }
    }

    $onInit() {
        this.scope.onContactListChanged();
    }
}

module.controller('OrderTabAddPeople', OrderTabAddPeopleController);



// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderTabAddPeopleController.js